import { connect } from 'react-redux'
import { closeModal, openEditFavouritesModal } from 'Modules/modals/actions'

import { googleAnalyticsEvent } from 'Modules/googleAnalytics/actions'
import FavouritesSection from './FavouritesSection'

export default connect((state) => ({
  userFavListings: state.userFavourites.userFavs && state.userFavourites.userFavs.listings,
  userFavBuildings: state.userFavourites.userFavs && state.userFavourites.userFavs.buildings,
}), {
  googleAnalyticsEvent,
  closeModal,
  openEditFavouritesModal,
})(FavouritesSection)
